"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceGroupOption = void 0;
var Utilities_1 = require("../../../Utilities");
var ChoiceGroupOption_base_1 = require("./ChoiceGroupOption.base");
var ChoiceGroupOption_styles_1 = require("./ChoiceGroupOption.styles");
exports.ChoiceGroupOption = Utilities_1.styled(ChoiceGroupOption_base_1.ChoiceGroupOptionBase, ChoiceGroupOption_styles_1.getStyles, undefined, { scope: 'ChoiceGroupOption' });
//# sourceMappingURL=ChoiceGroupOption.js.map